var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("div", { staticClass: "advantages-of-site ga-12 text-center" }, [
    _setup.context.stat.appointment_by_last_month
      ? _c("div", [
          _c("div", { class: _setup.isMobile ? "text-h6" : "text-h4" }, [
            _vm._v(
              "\n      " +
                _vm._s(
                  _setup.context.stat.appointment_by_last_month.toLocaleString(
                    "ru-RU"
                  )
                ) +
                "\n    "
            ),
          ]),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "text-secondary--text",
              class: _setup.isMobile ? "text-body-2" : "text-body-1",
            },
            [
              _vm._v(
                "\n      " +
                  _vm._s(
                    _setup.t(
                      "пациентов записывается через «{siteName}» на приём в частные клиники каждый месяц",
                      { ..._setup.options, siteName: _setup.siteName }
                    )
                  ) +
                  "\n    "
              ),
            ]
          ),
        ])
      : _vm._e(),
    _vm._v(" "),
    _c("div", [
      _c("div", { class: _setup.isMobile ? "text-h6" : "text-h4" }, [
        _vm._v(
          "\n      " +
            _vm._s(
              _setup.context.stat.prodoctorov_attendance.toLocaleString("ru-RU")
            ) +
            "\n    "
        ),
      ]),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "text-secondary--text",
          class: _setup.isMobile ? "text-body-2" : "text-body-1",
        },
        [
          _vm._v(
            "\n      " +
              _vm._s(
                _setup.t(
                  "пациентов приходит на «{siteName}» каждый месяц, чтобы найти хорошего доктора",
                  { ..._setup.options, siteName: _setup.siteName }
                )
              ) +
              "\n    "
          ),
        ]
      ),
    ]),
    _vm._v(" "),
    _c("div", [
      _c("div", { class: _setup.isMobile ? "text-h6" : "text-h4" }, [
        _vm._v(
          "\n      " +
            _vm._s(_setup.context.stat.rates_total.toLocaleString("ru-RU")) +
            "\n    "
        ),
      ]),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "text-secondary--text",
          class: _setup.isMobile ? "text-body-2" : "text-body-1",
        },
        [
          _vm._v(
            "\n      " +
              _vm._s(
                _setup.t(
                  "отзывов опубликовано пациентами на «{siteName}»{startYear}",
                  {
                    ..._setup.options,
                    siteName: _setup.siteName,
                    startYear: _setup.context.request.country.is_russia
                      ? " с 2011"
                      : " с 2024",
                  }
                )
              ) +
              "\n    "
          ),
        ]
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }